<template>
	<div class="legend-container is-flex my-5 center-flex-content">
		<div v-if="showCurrent" class="mr-3">
			<span class="bold size-lg" :style="styleCurrent">&horbar;&nbsp;</span>
			<span>{{ current.text }}</span>
		</div>
		<div v-if="showCompare" class="mr-3">
			<span class="bold size-lg" :style="styleCompare">&horbar;&nbsp;</span>
			<span>{{ compare.text }}</span>
		</div>
		<div v-if="showDashed" class="mr-3">
			<span class="bold size-lg" :style="styleDashed">&horbar;&nbsp;</span>
			<span>{{ dashed.text }}</span>
		</div>
	</div>
</template>
<script>
	import { ref } from "vue";

	export default {
		props: {
			current: {
				type: Object,
				default: () => {
					return {
						text: "Current",
						color: "#00aeef"
					};
				}
			},
			showCurrent: {
				type: Boolean,
				default: false
			},
			compare: {
				type: Object,
				default: () => {
					return {
						text: "Compare",
						color: "#d9017a"
					};
				}
			},
			showCompare: {
				type: Boolean,
				default: false
			},
			dashed: {
				type: Object,
				default: () => {
					return {
						text: "Partial",
						color: "#cccccc"
					};
				}
			},
			showDashed: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const styleCurrent = ref("color:" + props.current.color);
			const styleCompare = ref("color:" + props.compare.color);
			const styleDashed = ref("color:" + props.dashed.color);
			return {
				styleCurrent,
				styleCompare,
				styleDashed
			};
		}
	};
</script>
<style lang="scss" scoped>
	.bold {
		font-weight: bold;
	}
	.size-lg {
		font-size: 1.5rem;
	}
	.center-flex-content {
		justify-content: center;
	}

	.legend-container {
		cursor: default;
	}
</style>